import React, { useState, useEffect } from "react";
// import Lightbox from "yet-another-react-lightbox";
// import "yet-another-react-lightbox/styles.css";
import { initLightboxJS } from "lightbox.js-react";
import { SlideshowLightbox } from "lightbox.js-react";
function ArchivesSchema({
  formData,
  currentPage,
  setCurrentPage,
  fetchData,
  user,
  authLoading,
}) {
  const [selectedForm, setSelectedForm] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [open, setOpen] = useState(false);

  useEffect(() => {
    initLightboxJS("Insert_Your_License_Key_Or_Use_Default", "default");
  }, []);

  // Pagination state
  // const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25; // You can adjust this based on how many items you want per page

  // Calculate the number of pages
  const totalPages = Math.ceil(formData.length / itemsPerPage);

  // Get the current page's data
  const currentData = formData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const getStatusDotColor = (etat) => {
    switch (etat) {
      case "En attente":
        return "bg-orange-500";
      case "En traitement":
        return "bg-yellow-500";
      case "Rejeté":
        return "bg-red-500";
      case "Approuvé":
        return "bg-green-500";
      case "Supprimé":
        return "bg-red-700";
      default:
        return "bg-gray-500";
    }
  };

  const handleRowClick = (form) => {
    setSelectedForm(form);
  };

  const handleClosePopup = () => {
    setSelectedForm(null);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const FieldPair = ({ label1, value1, label2, value2 }) => {
    return (
      <div className=" w-[100%] grid grid-cols-2 gap-0">
        {label1 && (value1 || value1 === 0) && (
          <div className="w-3/5">
            <label className=" block text-sm font-medium text-blue-900">
              {label1} :
            </label>
            <input
              type="text"
              readOnly
              value={value1}
              className="mb-5 mt-1 w-full p-3 border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
          </div>
        )}

        {label2 && (value2 || value2 === 0) && (
          <div className=" w-3/5">
            <label className="block text-sm font-medium text-blue-900">
              {label2} :
            </label>
            <input
              type="text"
              readOnly
              value={value2}
              className="mb-5 mt-1 w-full p-3 border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
          </div>
        )}
      </div>
    );
  };

  const renderFormDetails = (form) => {
    return (
      <div className="">
        <div className="bg-gray-50 p-4 rounded-xl shadow-sm border border-gray-200 space-y-2">
          {form.formulaire &&
            form.formulaire === "Réclamation mensuelle de dépenses" && (
              <>
                <FieldPair
                  label1="Formulaire"
                  value1={form.formulaire}
                  label2="Numéro de formulaire"
                  value2={form.numeroFormulaire}
                />

                {form.dateSoumission && (
                  <FieldPair
                    label1="Date de Soumission"
                    value1={new Date(form.dateSoumission).toLocaleString(
                      "fr-FR",
                      {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      }
                    )}
                    label2={form.etatDemande ? "Statut de la Demande" : null}
                    value2={form.etatDemande}
                  />
                )}
                <FieldPair
                  label1={
                    form.periodReclamation ? "Période de la Réclamation" : null
                  }
                  value1={
                    form.periodReclamation
                      ? new Intl.DateTimeFormat("fr-CA", {
                          year: "numeric",
                          month: "long",
                          timeZone: "UTC",
                        }).format(new Date(form.periodReclamation))
                      : null
                  }
                />
                <FieldPair
                  label1="Finance"
                  value1={
                    form.commentsFinance?.length > 0
                      ? form.commentsFinance[0].personne
                      : null
                  }
                  label2="Date d'approbation"
                  value2={
                    form.commentsFinance?.length > 0
                      ? new Date(form.commentsFinance[0].date).toLocaleString(
                          "fr-FR",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          }
                        )
                      : null
                  }
                />
                <div className=" w-full bg-gradient-to-r from-gray-800 to-gray-600 py-1 shadow-md rounded-t-2xl">
                  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-blue-400 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.27.534 6.121 1.47M15 10a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                    Information du membre du personnel
                  </p>
                </div>
                <FieldPair
                  label1="Nom"
                  value1={form.nom}
                  label2={form.courriel ? "Courriel" : null}
                  value2={form.courriel}
                />

                <FieldPair
                  label1={form.posteOccupe ? "Poste" : null}
                  value1={form.posteOccupe}
                  label2={form.lieuTravail ? "Lieu de travail" : null}
                  value2={form.lieuTravail}
                />

                <FieldPair
                  label1={
                    form.soumisAutreMembre
                      ? "Soumis de la part d'un autre membre du personnel"
                      : null
                  }
                  value1={form.soumisAutreMembre === "Yes" ? "Oui" : "Non"}
                  label2={
                    form.soumisParAutreMembre_email
                      ? "soumis de la part de :"
                      : null
                  }
                  value2={`${form.soumisParAutreMembre_nom} ( ${form.soumisParAutreMembre_email} )`}
                />

                <FieldPair
                  label1={form.managerInfo_nom ? "Superviseur" : null}
                  value1={`${form.managerInfo_nom} ( ${form.managerInfo_email} )`}
                  label2={
                    form.managerInfo_etatDemande
                      ? "Superviseur - Approbation"
                      : null
                  }
                  value2={form.managerInfo_etatDemande}
                />
                <FieldPair />
                <FieldPair
                  label1={
                    form.verificationDelegue
                      ? "Vérification par délégué(e)"
                      : null
                  }
                  value1={form.verificationDelegue === "oui" ? "Oui" : "Non"}
                  label2={form.delegueInfo_nom ? "Délégué(e) :" : null}
                  value2={`${form.delegueInfo_nom} ( ${form.delegueInfo_email} )`}
                />

                <div className="mt-[4%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-1 shadow-md rounded-t-2xl">
                  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-green-400 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 10h.01M12 10h.01M16 10h.01M9 16h6M21 12c0 4.418-4.03 8-9 8s-9-3.582-9-8 4.03-8 9-8 9 3.582 9 8z"
                      />
                    </svg>
                    Questions
                  </p>
                </div>

                <div className="space-y-3">
                  {form.achatsCarteCréditProfessionnelle && (
                    <div className="p-3 bg-gray-50 rounded-xl shadow-sm">
                      <p className="text-gray-800">
                        <strong className="font-semibold text-gray-900">
                          Avez-vous effectué des achats avec votre carte de
                          crédit professionnelle Visa du Conseil ?
                        </strong>{" "}
                        <span
                          className={`ml-1 font-medium ${
                            form.achatsCarteCréditProfessionnelle === "Yes"
                              ? "text-green-600"
                              : "text-red-600"
                          }`}
                        >
                          {form.achatsCarteCréditProfessionnelle === "Yes"
                            ? "Oui"
                            : "Non"}
                        </span>
                      </p>
                    </div>
                  )}

                  {form.depensesEtrReclamer && (
                    <div className="p-3 bg-gray-50 rounded-xl shadow-sm">
                      <p className="text-gray-800">
                        <strong className="font-semibold text-gray-900">
                          Avez-vous des dépenses de 407 ETR à réclamer ?
                        </strong>{" "}
                        <span
                          className={`ml-1 font-medium ${
                            form.depensesEtrReclamer === "Yes"
                              ? "text-green-600"
                              : "text-red-600"
                          }`}
                        >
                          {form.depensesEtrReclamer === "Yes" ? "Oui" : "Non"}
                        </span>
                      </p>
                    </div>
                  )}

                  {form.depensesActiviteExterne && (
                    <div className="p-3 bg-gray-50 rounded-xl shadow-sm">
                      <p className="text-gray-800">
                        <strong className="font-semibold text-gray-900">
                          Avez-vous effectué des dépenses reliées à une
                          formation, colloque ou activité externe ?
                        </strong>{" "}
                        <span
                          className={`ml-1 font-medium ${
                            form.depensesActiviteExterne === "Yes"
                              ? "text-green-600"
                              : "text-red-600"
                          }`}
                        >
                          {form.depensesActiviteExterne === "Yes"
                            ? "Oui"
                            : "Non"}
                        </span>
                      </p>
                    </div>
                  )}

                  {form.reclameBoissonAlcoolise && (
                    <div className="p-3 bg-gray-50 rounded-xl shadow-sm">
                      <p className="text-gray-800">
                        <strong className="font-semibold text-gray-900">
                          Avez-vous réclamé de la boisson alcoolisée ?
                        </strong>{" "}
                        <span
                          className={`ml-1 font-medium ${
                            form.reclameBoissonAlcoolise === "Yes"
                              ? "text-green-600"
                              : "text-red-600"
                          }`}
                        >
                          {form.reclameBoissonAlcoolise === "Yes"
                            ? "Oui"
                            : "Non"}
                        </span>
                      </p>
                    </div>
                  )}
                </div>

                <div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-1 shadow-md rounded-t-2xl">
                  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-red-400 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8c-1.657 0-3 1.343-3 3 0 2.667 3 4 3 4s3-1.333 3-4c0-1.657-1.343-3-3-3zM12 2a10 10 0 100 20 10 10 0 000-20z"
                      />
                    </svg>
                    Compte budgétaire
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-xl shadow-sm border border-gray-200 space-y-2">
                  <FieldPair
                    label1={form.fonds ? "Fonds:" : null}
                    value1={form.fonds}
                    label2={form.centreCout ? "Centre de coût:" : null}
                    value2={form.centreCout}
                  />
                  <FieldPair
                    label1={form.ordre ? "Ordre:" : null}
                    value1={form.ordre}
                  />
                </div>
                <div className="mt-[6%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-1 shadow-md rounded-t-2xl">
                  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-purple-400 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8c-1.657 0-3 1.343-3 3 0 2.667 3 4 3 4s3-1.333 3-4c0-1.657-1.343-3-3-3zM12 2a10 10 0 100 20 10 10 0 000-20z"
                      />
                    </svg>
                    Dépenses
                  </p>
                </div>

                {/* Depenses visualization */}
                {form.depenses && form.depenses.length > 0 && (
                  <div className="mt-4 space-y-4">
                    <h3 className="text-lg font-semibold">Dépenses</h3>
                    {form.depenses.map((depense, index) => (
                      <div
                        key={index}
                        className="bg-white p-4 rounded-lg shadow border border-gray-200"
                      >
                        <FieldPair
                          label1={depense.dateDepense ? "Date" : null}
                          value1={new Date(
                            depense.dateDepense
                          ).toLocaleDateString("fr-FR")}
                          label2={
                            depense.descriptionDepense
                              ? "Description du déplacement ou de la dépense"
                              : null
                          }
                          value2={depense.descriptionDepense}
                        />
                        <FieldPair
                          label1={
                            depense.deplacement
                              ? "Point de départ-Destination-Point de retour"
                              : null
                          }
                          value1={depense.deplacement}
                        />

                        {/* Rows Table */}
                        {depense.rows && depense.rows.length > 0 && (
                          <table className="w-full mt-2 border border-gray-300 text-sm mb-5">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="border px-2 py-1">Type</th>
                                <th className="border px-2 py-1">Kms</th>
                                <th className="border px-2 py-1">
                                  Fournisseur
                                </th>
                                <th className="border px-2 py-1">Nature</th>
                                <th className="border px-2 py-1">Compte</th>
                                <th className="border px-2 py-1">Code taxe</th>
                                <th className="border px-2 py-1">Funds</th>
                                <th className="border px-2 py-1">
                                  Centre de coûts
                                </th>
                                <th className="border px-2 py-1">Ordre</th>
                                <th className="border px-2 py-1">Montant</th>
                                <th className="border px-2 py-1">
                                  Montant remboursé
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {depense.rows.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  <td className="border px-2 py-1">
                                    {row.typeDepenses}
                                  </td>
                                  <td className="border px-2 py-1">
                                    {row.kms}
                                  </td>
                                  <td className="border px-2 py-1">
                                    {row.fournisseur}
                                  </td>
                                  <td className="border px-2 py-1">
                                    {row.natureDepenses}
                                  </td>
                                  <td className="border px-2 py-1">
                                    {row.compte}
                                  </td>
                                  <td className="border px-2 py-1">
                                    {row.codeTaxe}
                                  </td>
                                  <td className="border px-2 py-1">
                                    {row.funds}
                                  </td>
                                  <td className="border px-2 py-1">
                                    {row.centreCouts}
                                  </td>
                                  <td className="border px-2 py-1">
                                    {row.ordre}
                                  </td>
                                  <td className="border px-2 py-1">
                                    {row.montant}
                                  </td>
                                  <td className="border px-2 py-1">
                                    {row.montantRembourser}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}

                        {/* Optional: Comments */}
                        {depense.commentsDepense &&
                          depense.commentsDepense.some(
                            (c) => c.commentaire || c.personne
                          ) && (
                            <div className="mt-5 mb-5">
                              <h3 className=" block text-sm font-medium text-blue-900">
                                Commentaires :
                              </h3>
                              <div className="space-y-1.5">
                                {depense.commentsDepense
                                  .filter((c) => c.commentaire || c.personne)
                                  .map((c, cIndex) => (
                                    <div
                                      key={cIndex}
                                      className="text-sm text-gray-800"
                                    >
                                      <span className="text-gray-500">
                                        [
                                        {c.date
                                          ? new Date(c.date).toLocaleDateString(
                                              "fr-FR"
                                            )
                                          : "Date inconnue"}
                                        ] {c.personne || "Anonyme"} :
                                      </span>{" "}
                                      {c.commentaire || ""}
                                    </div>
                                  ))}
                              </div>
                            </div>
                          )}

                        <FieldPair
                          label1={
                            depense.tousReçusFournis
                              ? "Avez-vous tous les reçus pour les dépenses ci-dessus"
                              : null
                          }
                          value1={
                            depense.tousReçusFournis === "Yes" ? "Oui" : "Non"
                          }
                        />
                        {/* Optional: Files */}
                        {depense.fichiersDepense &&
                          depense.fichiersDepense.some(
                            (f) => f.titre || f.url
                          ) && (
                            <div className="mt-2 space-y-1">
                              <strong>Fichiers:</strong>
                              {depense.fichiersDepense.map((f, fIndex) => (
                                <p key={fIndex}>
                                  <a
                                    href={f.url}
                                    target="_blank"
                                    className="text-blue-500 underline"
                                  >
                                    {f.titre}
                                  </a>
                                </p>
                              ))}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                )}

                {/* Visa Conseil */}
                {form.visaConseil_montantTotalReleveVisa !== 0 && (
                  <>
                    <div className="mt-[5%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-1 shadow-md rounded-t-2xl">
                      <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-indigo-400 mr-2"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7M12 20c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8z"
                          />
                        </svg>
                        Visa du Conseil
                      </p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-xl shadow-sm border border-gray-200 space-y-2">
                      {/* <p>
                <strong>Montant total relevé Visa:</strong>{" "}
                {form.visaConseil_montantTotalReleveVisa} $
              </p> */}
                      <FieldPair
                        label1={
                          form.posteOccupe ? "Montant total relevé Visa" : null
                        }
                        value1={`${form.visaConseil_montantTotalReleveVisa} $`}
                      />
                      {form.visaConseil_fichiers &&
                        form.visaConseil_fichiers.some(
                          (f) => f.titre || f.url
                        ) && (
                          <div className="space-y-1">
                            <strong>Fichiers Visa Conseil:</strong>
                            {form.visaConseil_fichiers
                              .filter((f) => f.titre || f.url) // garder seulement ceux avec du contenu
                              .map((f, index) => (
                                <p key={index}>
                                  {f.url ? (
                                    <a
                                      href={f.url}
                                      target="_blank"
                                      className="text-blue-500 underline"
                                    >
                                      {f.titre || "Fichier"}
                                    </a>
                                  ) : (
                                    f.titre || "Fichier sans lien"
                                  )}
                                </p>
                              ))}
                          </div>
                        )}
                    </div>
                  </>
                )}

                {/* ETR */}
                {form.etr_fichiers &&
                  form.etr_fichiers.some((f) => f.titre || f.url) && (
                    <>
                      <div className="mt-[5%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-1 shadow-md rounded-t-2xl">
                        <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-orange-400 mr-2"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M3 10h18M3 14h18M5 6h14M5 18h14"
                            />
                          </svg>
                          407 ETR
                        </p>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-xl shadow-sm border border-gray-200 space-y-2">
                        <h3 className="text-lg font-semibold">ETR (407)</h3>
                        {form.etr_fichiers
                          .filter((f) => f.titre || f.url) // filtrer les fichiers vides
                          .map((f, index) => (
                            <p key={index}>
                              {f.url ? (
                                <a
                                  href={f.url}
                                  target="_blank"
                                  className="text-blue-500 underline"
                                >
                                  {f.titre || "Fichier"}
                                </a>
                              ) : (
                                f.titre || "Fichier sans lien"
                              )}
                            </p>
                          ))}
                      </div>
                    </>
                  )}

                {/* Formation */}
                {(form.formation_date ||
                  form.formation_nom ||
                  (form.formation_fichiers &&
                    form.formation_fichiers.some((f) => f.titre || f.url))) && (
                  <>
                    <div className="mt-[5%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
                      <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-teal-400 mr-2"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 14l9-5-9-5-9 5 9 5zm0 0v6m0-6L3 9m9 5l9-5"
                          />
                        </svg>
                        Formation
                      </p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-xl shadow-sm border border-gray-200 space-y-2">
                      {form.formation_date && (
                        <FieldPair
                          label1="Date"
                          value1={new Date(
                            form.formation_date
                          ).toLocaleDateString("fr-FR")}
                        />
                      )}
                      {form.formation_nom && (
                        <FieldPair
                          label1="Nom de la formation, colloque ou activité externe"
                          value1={form.formation_nom}
                        />
                      )}
                      {form.formation_fichiers &&
                        form.formation_fichiers.some(
                          (f) => f.titre || f.url
                        ) && (
                          <div className="space-y-1">
                            <strong>Fichiers Formation:</strong>
                            {form.formation_fichiers
                              .filter((f) => f.titre || f.url)
                              .map((f, index) => (
                                <p key={index}>
                                  {f.url ? (
                                    <a
                                      href={f.url}
                                      target="_blank"
                                      className="text-blue-500 underline"
                                    >
                                      {f.titre || "Fichier"}
                                    </a>
                                  ) : (
                                    f.titre || "Fichier sans lien"
                                  )}
                                </p>
                              ))}
                          </div>
                        )}
                      {form.formation_comments &&
                        form.formation_comments.some(
                          (c) => c.commentaire || c.personne
                        ) && (
                          <div className="space-y-1">
                            <strong>Commentaires Formation:</strong>
                            {form.formation_comments.map((c, index) => (
                              <p key={index}>
                                [{new Date(c.date).toLocaleDateString("fr-FR")}]{" "}
                                {c.personne}: {c.commentaire}
                              </p>
                            ))}
                          </div>
                        )}
                    </div>
                  </>
                )}

                <div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-1 shadow-md rounded-t-2xl">
                  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-pink-400 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 17v-6h6v6m2 4H7a2 2 0 01-2-2V7a2 2 0 012-2h5l2 2h5a2 2 0 012 2v12a2 2 0 01-2 2z"
                      />
                    </svg>
                    Sommaire des dépenses réclamées
                  </p>
                </div>

                {/* Montants */}
                <div className="bg-gray-50 p-4 rounded-xl shadow-sm border border-gray-200 space-y-2">
                  <FieldPair
                    label1={
                      form.montantkilometrage ? "Montant du kilométrage" : null
                    }
                    value1={
                      form.montantkilometrage
                        ? `${form.montantkilometrage} $`
                        : 0
                    }
                    label2={"Montant des dépenses Visa du Conseil"}
                    value2={
                      form.montantVisaConseil
                        ? `${form.montantVisaConseil} $`
                        : 0
                    }
                  />

                  <FieldPair
                    label1={"Montant des autres dépenses"}
                    value1={
                      form.montantAutresDepenses
                        ? `${form.montantAutresDepenses} $`
                        : 0
                    }
                  />

                  <FieldPair
                    label1={"Montant à rembourser au Conseil"}
                    value1={
                      form.montantRembourserConseil
                        ? `${form.montantRembourserConseil} $`
                        : 0
                    }
                  />

                  <FieldPair
                    label1={"Montant net"}
                    value1={form.montantNet ? `${form.montantNet} $` : 0}
                  />

                </div>
              </>
            )}


          {form.formulaire &&
            form.formulaire === "Changement information bancaire" && (
              <>
                <FieldPair
                  label1="Formulaire"
                  value1={form.formulaire}
                  label2="Numéro de formulaire"
                  value2={form.numeroFormulaire}
                />

                {form.dateSoumission && (
                  <FieldPair
                    label1="Date de Soumission"
                    value1={new Date(form.dateSoumission).toLocaleString(
                      "fr-FR",
                      {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      }
                    )}
                    label2={form.etatDemande ? "Statut de la Demande" : null}
                    value2={form.etatDemande}
                  />
                )}
                <FieldPair
                  label1="Nom"
                  value1={form.nom}
                />
                <FieldPair
                  label1="Banque"
                  value1={form.banque}
                />
                <FieldPair
                  label1="Numéro de transit"
                  value1={form.numeroTransit}
                  label2="Numéro de compte"
                  value2={form.numeroCompte}
                />
                <FieldPair
                  label1="Commentaire"
                  value1={form.commentaires}
                />

                {form.fichiers &&
                        form.fichiers.some(
                          (f) => f.titre || f.url
                        ) && (
                          <div className="space-y-1">
                            <strong>Fichiers :</strong>
                            {form.fichiers
                              .filter((f) => f.titre || f.url)
                              .map((f, index) => (
                                <p key={index}>
                                  {f.url ? (
                                    <a
                                      href={f.url}
                                      target="_blank"
                                      className="text-blue-500 underline"
                                    >
                                      {f.titre || "Fichier"}
                                    </a>
                                  ) : (
                                    f.titre || "Fichier sans lien"
                                  )}
                                </p>
                              ))}
                          </div>
                        )}

                </>
            )}


          {form.formulaire &&
            form.formulaire === "Déclaration annuelle" && (
              <>
                <FieldPair
                  label1="Formulaire"
                  value1={form.formulaire}
                  label2="Numéro de formulaire"
                  value2={form.numeroFormulaire}
                />

                 {form.dateSoumission && (
                  <FieldPair
                    label1="Date de Soumission"
                    value1={new Date(form.dateSoumission).toLocaleString(
                      "fr-FR",
                      {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      }
                    )}
                    label2={form.etatDemande ? "Statut de la Demande" : null}
                    value2={form.etatDemande}
                  />
                )}
                <div className="space-y-6"> {/* 👈 gère l'espacement entre chaque bloc */}
                <FieldPair
                  label1="Nom"
                  value1={form.nom.match(/Je\s*,\s*(.*?)\s*,\s*déclare/i)?.[1]}
                  label2="Matricule"
                  value2={form.matricule}
                />

                
                <p className="text-gray-700 leading-relaxed">
                  <strong>{form.nom}</strong>{" "}
                  {form.reconnuCoupable === "true" ? (
                    <>
                      Depuis ma dernière déclaration annuelle ou de mon dernier relevé
                      d’antécédents criminels pour enfants et personnes vulnérables, qui a été
                      soumis au Conseil ou à l'Ordre des enseignantes et des enseignants de
                      l'Ontario, le cas échéant, j’ai été reconnu ou reconnue coupable d’une ou
                      plusieurs infractions selon le <em>Code criminel du Canada</em>.
                    </>
                  ) : (
                    <>
                      Je n’ai pas été reconnu ou reconnue coupable d’une disposition au{" "}
                      <em>Code criminel du Canada</em> depuis ma dernière déclaration annuelle
                      ou de mon dernier relevé d’antécédents criminels pour enfants et personnes
                      vulnérables, qui a été soumis au Conseil ou à l'Ordre des enseignantes et
                      enseignants de l'Ontario, le cas échéant.
                    </>
                  )}
                </p>

                {form.conviction_LookupDataGrid && form.conviction_LookupDataGrid.length > 0 && (
                  <div className="mt-4">
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Détails des condamnations</h3>
                    <div className="overflow-x-auto rounded-2xl shadow-sm border border-gray-200">
                      <table className="min-w-full text-sm text-left text-gray-700">
                        <thead className="bg-gray-100 text-gray-800 uppercase text-xs font-semibold">
                          <tr>
                            <th className="px-5 py-3">Infraction</th>
                            <th className="px-5 py-3">Date</th>
                            <th className="px-5 py-3">Lieu</th>
                            <th className="px-5 py-3">Commentaire</th>
                          </tr>
                        </thead>
                        <tbody>
                          {form.conviction_LookupDataGrid.map((item, index) => (
                            <tr
                              key={item._id || index}
                              className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                            >
                              <td className="px-5 py-3 font-medium">{item.conviction.convictionname}</td>
                              <td className="px-5 py-3">
                                {new Date(item.conviction.convictiondate).toLocaleDateString("fr-CA", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                })}
                              </td>
                              <td className="px-5 py-3">{item.conviction.convictionlocation}</td>
                              <td className="px-5 py-3 italic text-gray-600">
                                {item.conviction.convictioncomment || "—"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {form.chkboxsign === "DOI" && (
                  <div className="mt-5 flex items-start space-x-2">
                    <input
                      type="checkbox"
                      checked
                      readOnly
                      className="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-default"
                    />
                    <label className="text-gray-800 text-sm leading-relaxed">
                      Je confirme que toutes les données concernant cette{" "}
                      <span className="font-semibold">déclaration annuelle</span> sont exactes et complètes.
                    </label>
                  </div>
                )}
                </div>
              </>
              

            )}
          
          
          {form.reconnuCoupableDepuisDerniereDeclaration && (
            <p>
              <strong>Reconnu coupable depuis derniere declaration : </strong>{" "}
              {form.reconnuCoupableDepuisDerniereDeclaration}
            </p>
          )}
          {form.declarationExacteEtComplete && (
            <p>
              <strong>Declaration exacte et complete : </strong>{" "}
              {form.declarationExacteEtComplete}
            </p>
          )}
          {form.dateDeclaration && (
            <p>
              <strong>Date de declaration : </strong> {form.dateDeclaration}
            </p>
          )}
          {form.dispositions && form.dispositions.length > 0 && (
            <div>
              <strong>Dispositions :</strong>
              {form.dispositions.map((disposition, index) => (
                <div
                  key={index}
                  style={{ marginLeft: "20px", marginTop: "5px" }}
                >
                  <p>
                    <strong>Infractions :</strong> {disposition.infractions}
                  </p>
                  <p>
                    <strong>Date :</strong> {disposition.date}
                  </p>
                  <p>
                    <strong>Tribunal :</strong> {disposition.tribunal}
                  </p>
                  <p>
                    <strong>Commentaire :</strong> {disposition.commentaire}
                  </p>
                </div>
              ))}
            </div>
          )}

          {form.nomMembre && (
            <p>
              <strong>Nom du membre du personnel: </strong> {form.nomMembre}
            </p>
          )}
          {form.prenomMembre && (
            <p>
              <strong>Prénom du membre du personnel: </strong>{" "}
              {form.prenomMembre}
            </p>
          )}
          {form.posteMembre && (
            <p>
              <strong>Poste du membre du personnel: </strong> {form.posteMembre}
            </p>
          )}

          {form.adressePostalResidentielle === "non" && (
            <p className="mt-3 block text-md font-medium text-blue-900">
              <strong>Adresse Résidentielle </strong>
            </p>
          )}

          {form.adresse && (
            <p>
              <strong>Adresse: </strong> {form.adresse}
            </p>
          )}

          {form.numeroappartement && (
            <p>
              <strong>Appartement: </strong> {form.numeroappartement}
            </p>
          )}

          {form.ville && (
            <p>
              <strong>Ville: </strong> {form.ville}
            </p>
          )}
          {form.province && (
            <p>
              <strong>Province: </strong> {form.province}
            </p>
          )}
          {form.codePostal && (
            <p>
              <strong>Code Postal: </strong> {form.codePostal}
            </p>
          )}

          {form.adressePostalResidentielle === "non" && (
            <p className="mt-3 block text-md font-medium text-blue-900">
              <strong>Adresse Postale </strong>
            </p>
          )}

          {form.adressePostalResidentielle === "non" && form.boitePostale && (
            <p>
              <strong>Boite Postale: </strong> {form.boitePostale}
            </p>
          )}

          {form.adressePostalResidentielle === "non" &&
            form.appartementPostale && (
              <p>
                <strong>Appartement / unité : </strong>{" "}
                {form.appartementPostale}
              </p>
            )}

          {form.adressePostalResidentielle === "non" && form.villePostale && (
            <p>
              <strong>Ville: </strong> {form.villePostale}
            </p>
          )}
          {form.adressePostalResidentielle === "non" &&
            form.provincePostale && (
              <p>
                <strong>Province: </strong> {form.provincePostale}
              </p>
            )}
          {form.adressePostalResidentielle === "non" &&
            form.codePostalPostale && (
              <p>
                <strong>Code Postal: </strong> {form.codePostalPostale}
              </p>
            )}

          {form.telephone && (
            <p className="mt-3">
              <strong>Numéro de téléphone principal: </strong>{" "}
              {`${form.telephone.slice(0, 3)} ${form.telephone.slice(
                3,
                6
              )} ${form.telephone.slice(6, 10)}`}
            </p>
          )}

          {form.telephoneCellulaire && (
            <p>
              <strong>Autre numéro de téléphone (optionnel): </strong>{" "}
              {`${form.telephoneCellulaire.slice(
                0,
                3
              )} ${form.telephoneCellulaire.slice(
                3,
                6
              )} ${form.telephoneCellulaire.slice(6, 10)}`}
            </p>
          )}
          {form.dateEntreeEnVigueur && (
            <p>
              <strong>Date d'entrée en vigueur: </strong>{" "}
              {form.dateEntreeEnVigueur}
            </p>
          )}
          {form.dateDebut && (
            <p>
              <strong>Date de début: </strong> {form.dateDebut}
            </p>
          )}
          {form.dateFin && (
            <p>
              <strong>Date de fin: </strong> {form.dateFin}
            </p>
          )}
          {form.courrielSuperviseur && (
            <p>
              <strong>Courriel du superviseur: </strong>{" "}
              {form.courrielSuperviseur}
            </p>
          )}
          {form.nouveauNom && (
            <p>
              <strong>Nouveau Nom : </strong> {form.nouveauNom}
            </p>
          )}
          {form.nouveauPrenom && (
            <p>
              <strong>Nouveau Prénom : </strong> {form.nouveauPrenom}
            </p>
          )}
          {form.deuxiemePrenom && (
            <p>
              <strong>Deuxième Prénom : </strong> {form.deuxiemePrenom}
            </p>
          )}
          {form.institution && (
            <p>
              <strong>Institution : </strong> {form.institution}
            </p>
          )}
         

          {form.commentairesDemandeur && (
            <p>
              <strong>Commentaires du demandeur: </strong>{" "}
              {form.commentairesDemandeur}
            </p>
          )}
          {form.documentJustificatif && (
            <p>
              <strong>document justificatif : </strong>{" "}
              {form.documentJustificatif}
            </p>
          )}
          {form.uploadedFile && (
            <div className="mt-3 w-full flex items-center space-x-4">
              <p
                className="border rounded-lg px-4 py-2 w-[50%] bg-blue-900 text-white cursor-pointer inline-block hover:bg-blue-700 transition duration-200"
                onClick={() => setShowPopup(true)}
              >
                Voir le document : {form.uploadedFile.filename}
              </p>
            </div>
          )}
          {showPopup && form.uploadedFile?.data && (
            <>
              <div
                className="fixed inset-0 bg-black bg-opacity-50 z-40"
                onClick={closePopup}
              ></div>
              <div className="fixed w-[60%] h-[80%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 bg-white border shadow-lg rounded-lg z-50">
                <div className="flex justify-between items-center">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800">
                      Aperçu du fichier
                    </h3>
                    {form.uploadedFile.contentType?.startsWith("image/") && (
                      <p className="text-sm text-gray-500">
                        Cliquez sur l’image pour l’agrandir
                      </p>
                    )}
                  </div>
                  <button
                    onClick={closePopup}
                    className="text-gray-500 hover:text-gray-700 font-bold text-xl"
                  >
                    X
                  </button>
                </div>

                {/* Image preview */}
                {form.uploadedFile.contentType?.startsWith("image/") && (
                  //   <>
                  //   <img
                  //     src={`data:${form.uploadedFile.contentType};base64,${form.uploadedFile.data}`}
                  //     alt={form.uploadedFile.filename || "Uploaded File"}
                  //     onClick={() => setOpen(true)}
                  //     className="max-w-full max-h-[500px] rounded-lg mt-4 object-contain border cursor-pointer"
                  //   />
                  //   <Lightbox
                  //     open={open}
                  //     close={() => setOpen(false)}
                  //     slides={[
                  //       {
                  //         src: `data:${form.uploadedFile.contentType};base64,${form.uploadedFile.data}`,
                  //       },
                  //     ]}
                  //   />
                  // </>

                  <SlideshowLightbox className="mx-auto">
                    <img
                      src={`data:${form.uploadedFile.contentType};base64,${form.uploadedFile.data}`}
                      alt="Aperçu"
                      className="max-w-full max-h-[500px] rounded-lg border cursor-zoom-in"
                    />
                  </SlideshowLightbox>
                )}

                {/* PDF preview */}
                {form.uploadedFile.contentType === "application/pdf" && (
                  <iframe
                    src={`data:application/pdf;base64,${form.uploadedFile.data}`}
                    title="PDF preview"
                    className="w-[100%] h-[90%] border mt-4"
                  />
                )}
              </div>
            </>
          )}

          {form.listeDesNotes && form.listeDesNotes.length > 0 && (
            <div className="mt-4">
              <strong>Commentaires :</strong>
              <table className="min-w-full mt-2 border border-gray-300 table-fixed">
                <thead className="bg-blue-700">
                  <tr>
                    <th className="p-3 text-left text-white text-sm font-medium">
                      Nom
                    </th>
                    <th className="p-3 text-left text-white text-sm font-medium">
                      Courriel
                    </th>
                    <th className="p-3 text-left text-white text-sm font-medium">
                      Commentaire
                    </th>
                    <th className="p-3 text-left text-white text-sm font-medium">
                      Date et heure
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {form.listeDesNotes.map((t, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="border px-1 py-2 break-words">{t.nom}</td>
                      <td className="border px-1 py-1 break-words">
                        {t.courriel}
                      </td>
                      <td className="border px-1 py-1">{t.commentaireUsers}</td>
                      <td className="border px-6 py-2">{t.dateHeure}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* {form.commentaire && form.commentaireVisible === "oui" && (
          <p className="mt-4 text-lg text-gray-700">
            <strong className="text-blue-600">Note du traiteur :</strong> {form.commentaire}
          </p>
        )} */}
          {form.commentaire && form.commentaireVisible === "oui" && (
            <p className="mt-4 text-lg text-gray-700">
              <strong
                className={
                  form.etatDemande === "Approuvé"
                    ? "text-green-600"
                    : form.etatDemande === "Rejeté"
                    ? "text-red-600"
                    : "text-gray-600"
                }
              >
                Note du traiteur :
              </strong>{" "}
              {form.commentaire}
            </p>
          )}
        </div>
      </div>
    );
  };

  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    content: "",
  });

  const handleMouseEnter = (e, content) => {
    const rect = e.target.getBoundingClientRect();
    setTooltip({
      visible: true,
      x: rect.left + 10, // Tooltip appears to the right
      y: rect.top,
      content,
    });
  };

  const handleMouseLeave = () => {
    setTooltip({ visible: false, x: 0, y: 0, content: "" });
  };

  const generateText = (etatDemande) => {
    switch (etatDemande) {
      case "En attente":
        return "La demande est en attente d'approbation par les gestionnaires de tâches.";
      case "En traitement":
        return "La demande est en cours de traitement par les gestionnaires de tâches.";
      case "Rejeté":
        return "La demande a été rejetée par les gestionnaires de tâches.";
      case "Approuvé":
        return "La demande a été approuvée par les gestionnaires de tâches.";
      case "Supprimé":
        return "La demande a été supprimée par l'utilisateur.";
      default:
        return "La demande est encore à l'état de brouillon et n'est pas complète.";
    }
  };

  return (
    <div className="p-4">
      <div className=" w-full">
        <h2 className="text-2xl font-bold mb-2 text-gray-800">
          Liste des Demandes
        </h2>
        <div className="flex items-start gap-3 bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg mb-6">
          {/* Icône info */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-blue-500 mt-0.5 flex-shrink-0"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"
            />
          </svg>

          <p className="text-gray-700 text-base">
            Les données affichées dans le tableau correspondent aux{" "}
            <strong>deux derniers mois</strong>. Pour consulter des données plus
            anciennes, veuillez utiliser le filtrage et sélectionner
            l’intervalle de dates souhaité.
          </p>
        </div>
        <div className="overflow-x-auto rounded-xl shadow-lg border border-gray-200">
          <table className="min-w-full bg-white divide-y divide-gray-200">
            <thead className="bg-blue-600 rounded-t-xl">
              <tr>
                {[
                  "Formulaire",
                  "Nom",
                  "Numéro du formulaire",
                  "Date",
                  "Statut",
                ].map((title) => (
                  <th
                    key={title}
                    className="px-5 py-3 text-left text-sm font-semibold text-white"
                  >
                    {title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {authLoading ? (
                <tr>
                  <td colSpan="6" className="py-6 text-center">
                    <div className="flex items-center justify-center">
                      <div className="w-6 h-6 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                      <p className="ml-3 text-gray-700 font-medium">
                        Chargement en cours...
                      </p>
                    </div>
                  </td>
                </tr>
              ) : (
                currentData.map((form, index) => (
                  <tr
                    key={index}
                    onClick={() => handleRowClick(form)}
                    className="cursor-pointer hover:bg-blue-50 hover:shadow-md transition-transform duration-200 ease-in-out"
                  >
                    <td className="px-5 py-3 text-gray-700">
                      {form.formulaire}
                      {form.periodReclamation && (
                        <>
                          {" "}
                          -{" "}
                          {new Intl.DateTimeFormat("fr-CA", {
                            year: "numeric",
                            month: "long",
                            timeZone: "UTC",
                          }).format(new Date(form.periodReclamation))}
                        </>
                      )}
                    </td>
                    <td className="px-5 py-3 text-gray-700">{form.formulaire!=="Déclaration annuelle"?form.nom : form.nom.match(/Je\s*,\s*(.*?)\s*,\s*déclare/i)?.[1] || ""}</td>
                    <td className="px-5 py-3 text-gray-700">
  {form.formulaire !== "Déclaration annuelle"
    ? form.numeroFormulaire
    : form.numeroFormulaire.split("Fri")[0] + "Fri"}
</td>
                    <td className="px-5 py-3 text-gray-700">
                      {new Date(form.dateSoumission).toLocaleString("fr-FR", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                    </td>
                    <td className="px-5 py-3">
                      <span
                        className="flex items-center"
                        onMouseEnter={(e) =>
                          handleMouseEnter(e, generateText(form.etatDemande))
                        }
                        onMouseLeave={handleMouseLeave}
                      >
                        {form.formulaire !== "Déclaration annuelle" ?
                        <span
                          className={`inline-block w-3 h-3 rounded-full mr-2 ${getStatusDotColor(
                            form.etatDemande
                          )}`}
                        ></span> :""}
                        <span className="font-medium text-gray-700">
                          {form.etatDemande}
                        </span>
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination Controls */}
      <div className="mt-4 flex justify-center items-center space-x-4">
        <button
          onClick={() => {
            window.scrollTo({ top: 280, behavior: "smooth" });
            setCurrentPage((prev) => Math.max(prev - 1, 1));
          }}
          className="px-4 py-2 rounded-md bg-gray-200 text-gray-700 font-medium hover:bg-gray-300 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={currentPage === 1}
        >
          Précédent
        </button>

        <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-800 font-medium">
          {currentPage} sur {totalPages}
        </span>

        <button
          onClick={() => {
            setCurrentPage((prev) => Math.min(prev + 1, totalPages));
            window.scrollTo({ top: 280, behavior: "smooth" });
          }}
          className="px-4 py-2 rounded-md bg-gray-200 text-gray-700 font-medium hover:bg-gray-300 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={currentPage === totalPages}
        >
          Suivant
        </button>
      </div>

      {tooltip.visible && (
        <div
          className="absolute bg-white border border-gray-300 rounded-md w-[10%] p-2 shadow-lg z-50"
          style={{
            left: tooltip.x,
            top: tooltip.y,
          }}
        >
          {tooltip.content}
        </div>
      )}

      {/* Main Popup Modal */}
      {selectedForm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex justify-center items-start z-50 pt-10">
          <div className="bg-white p-8 rounded-2xl shadow-2xl w-[80%] max-w-[1200px] max-h-[90vh] overflow-y-auto relative">
            {/* Close Button X */}
            <button
              onClick={handleClosePopup}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 text-xl font-bold"
              aria-label="Fermer"
            >
              X
            </button>
            {/* Header */}
            <h2 className="text-2xl font-bold mb-4 text-gray-800 border-b pb-2">
              Détails de la Demande
            </h2>

            {/* Form Details */}
            <div className="overflow-y-auto">
              {renderFormDetails(selectedForm)}
            </div>

            {/* Action Buttons */}
            <div className="mt-6 flex justify-end items-center">
              <button
                className="px-4 py-2 rounded-lg bg-gray-200 text-gray-800 font-semibold shadow-sm hover:bg-gray-300 transition-colors duration-200"
                onClick={handleClosePopup}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Popup */}
      {/* {showDeleteConfirmation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-1/3">
            <h2 className="text-xl font-semibold mb-4">
              Confirmer la Suppression
            </h2>
            <p>Êtes-vous sûr de vouloir supprimer cette demande ?</p>
            <div className="mt-4 flex justify-end space-x-2">
              <button
                onClick={confirmDelete}
                className="bg-red-500 text-white px-4 py-2 rounded"
              >
                Confirmer
              </button>
              <button
                onClick={() => setShowDeleteConfirmation(false)}
                className="bg-gray-300 text-black px-4 py-2 rounded"
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      )} */}

      {isLoading && (
        <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
          <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
          <p className="ml-3 text-gray-700 font-medium">
            Chargement en cours...
          </p>
        </div>
      )}
    </div>
  );
}

export default ArchivesSchema;
